module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 24l9-16 9 16H7zm10-2v-2h-2v2h2zm0-4v-4h-2v4h2z\"></path></svg>"